import React, { useState } from 'react';
import { PageLayout } from '../../../common/components/Layout/PageLayout';
import { LayoutContent } from '../../../common/components/Layout/Layout';
import { PageTitle } from '../../../common/components/ui/PageTitle/PageTitle';
import { queryLoader } from '../../../common/components/utils/queryLoader';
import { VacationApplicationType } from '../../../graphql/types';
import { useVacationSchedules } from '../../../graphql/hooks/vacations/useVacationSchedules';
import { useVacationBalances } from '../../../graphql/hooks/vacations/useVacationBalances';
import { VacationSchedules } from './VacationSchedules/VacationSchedules';
import { VacationAppForm } from './VacationAppForm/VacationAppForm';
import { VacationArchive } from './VacationArchive/VacationArchive';
import s from './VacationAppPage.module.scss';

const title = 'Отпуск (кроме категории ППС)';
const caption = (
  <>
    В этом разделе вы сможете подать заявление на внесение изменений в график
    отпусков, сформировать заявление на нераспределенные дни отпуска и направить
    его в электронном виде на согласование вашему руководителю и в отдел кадров.
    <br />
    <br />
    Статус заявления с резолюцией руководителя можно отслеживать в разделе Архив
    отпусков.
  </>
);

export default function VacationAppPage() {
  const [vacationApps, setVacationApps] = useState<VacationApplicationType[]>(
    []
  );

  const vacationSchedulesQuery = useVacationSchedules();
  const vacationSchedules = vacationSchedulesQuery.state.data;

  const vacationBalancesQuery = useVacationBalances();
  const vacationBalances = vacationBalancesQuery.state.data;

  return (
    <PageLayout>
      <LayoutContent>
        <PageTitle
          className={s.VacationAppPage__pageTitle}
          captionClassName={s.VacationAppPage__pageCaption}
          title={title}
          caption={caption}
          showHeading={true}
        />

        {queryLoader(vacationSchedulesQuery) || (
          <>
            <div className={s.VacationAppPage__confirmedList}>
              <VacationSchedules
                vacationsSchedules={vacationSchedules}
                vacationApps={vacationApps}
                vacationBalances={vacationBalances}
              />
            </div>

            <div className={s.VacationAppPage__form}>
              <VacationAppForm
                vacationsSchedules={vacationSchedules}
                vacationApps={vacationApps}
                vacationBalances={vacationBalances}
              />
            </div>
          </>
        )}

        <div className={s.VacationAppPage__archive}>
          <VacationArchive onVacationAppsChange={setVacationApps} />
        </div>
      </LayoutContent>
    </PageLayout>
  );
}
